import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Modal, Input, Typography, Spin } from 'antd';
import { sendUserFeedback } from '../common/common_action';
import { getChannelList } from 'components/skills/skills_action';

class FeedbackModal extends Component {
  constructor() {
    super();
    this.state = {
      feedback_text: '',
      feedback_desc: '',
      feedbacksent: false,
      error: false,
      loading: false,
    };
  }

  componentDidMount() {
    const { channels, workspace } = this.props;
    if (workspace.customFeedbackChannel && channels.length === 0) {
      this.setState({ loading: true });
      this.props.getChannelList(this.props.match.params.wId).then((res) => {
        if (res && res.data && res.data.success)
          this.setState({ loading: false });
      });
    }
  }

  sendFeedback = () => {
    const { feedback_text } = this.state;
    const { user_now } = this.props;
    const clean_feedback_text = feedback_text
      ? feedback_text.replace(/</g, '&lt;').replace(/>/g, '&gt;')
      : '';
    this.setState({ feedback_desc: clean_feedback_text });
    if (clean_feedback_text.trim().length > 0) {
      const data = {
        workspace_id: this.props.match.params.wId,
        user_feedback: clean_feedback_text,
        user_id: user_now._id,
      };
      this.props.sendUserFeedback(data).then((res) => {
        // this.props.toggleFeedbackModal()
        this.setState({ feedback_text: '', feedbacksent: true, error: false });
      });
    } else {
      this.setState({ error: true });
    }
  };

  handle_feedback_change = (e) => {
    this.setState({ feedback_text: e.target.value, error: false });
  };

  handleModalClose = () => {
    this.setState({ feedbacksent: false, feedback_text: '', error: false });
    this.props.toggleFeedbackModal();
  };

  render() {
    const { workspace, user_now, channels } = this.props;
    const { feedbacksent, error, feedback_desc } = this.state;
    const trooprDocsDefaultUrl = 'https://docs.troopr.ai/';
    const help_docs_link =
      workspace.customHelpDocsLink && workspace.enableInternalFeedback
        ? workspace.customHelpDocsLink
        : trooprDocsDefaultUrl;
    const selectedChannel = channels.find(
      (cha) => cha.id === workspace.customFeedbackChannel
    );
    return (
      <Modal
        title={
          workspace.enableInternalFeedback
            ? 'Submit Your Feedback'
            : 'Troopr Feedback'
        }
        visible={this.props.feedback_modal_visible}
        onOk={feedbacksent ? this.handleModalClose : this.sendFeedback}
        onCancel={this.handleModalClose}
        okText={feedbacksent ? 'Ok' : 'Submit'}
        cancelText='Cancel'
        // afterClose={this.handleModalClose}
      >
        {this.state.loading ? (
          <Spin style={{ marginLeft: 230 }} />
        ) : (
          <>
            {!this.state.feedbacksent ? (
              <>
                {' '}
                <Typography.Text strong>Feedback</Typography.Text>
                <Input.TextArea
                  onChange={(e) => this.handle_feedback_change(e)}
                  value={this.state.feedback_text}
                  placeholder={
                    workspace.enableInternalFeedback
                      ? 'Write a request or feedback to team'
                      : 'Write a request or feedback to Troopr'
                  }
                  rows={4}
                />
                {error && (
                  <>
                    <Typography.Text type='danger'>
                      *Field is required
                    </Typography.Text>
                    <br />
                  </>
                )}
                {!workspace.customFeedbackemail && (
                  <Typography.Text type='secondary'>
                    Someone from the Troopr support team will get back to you
                    soon
                    <br />
                  </Typography.Text>
                )}
                <Typography.Text type='secondary'>
                  {`For ${
                    !workspace.enableInternalFeedback ? 'Troopr ' : ''
                  }help docs, visit `}
                  <Typography.Link href={help_docs_link} target='_blank'>
                    here
                  </Typography.Link>
                </Typography.Text>
              </>
            ) : (
              <>
                <span>
                  <Typography.Text>
                    Thank you for your feedback! It has been sent to
                  </Typography.Text>
                  {workspace.enableInternalFeedback ? (
                    <>
                      {workspace.customFeedbackemail && (
                        <a href={`mailto:${workspace.customFeedbackemail}`}>
                          {' ' + workspace.customFeedbackemail}
                        </a>
                      )}
                      {workspace.customFeedbackemail &&
                      workspace.customFeedbackChannel
                        ? ' and'
                        : ''}
                      {workspace.customFeedbackChannel &&
                        selectedChannel.name &&
                        workspace.slackTeam.id && (
                          <a
                            href={`https://slack.com/app_redirect?team=${workspace.slackTeam.id}&channel=${workspace.customFeedbackChannel}`}
                            target='_blank'
                          >
                            {` #${selectedChannel.name}`}
                          </a>
                        )}
                      .
                    </>
                  ) : (
                    <Typography.Text>{' ' + 'Troopr Team.'}</Typography.Text>
                  )}
                </span>
                <br />
                <br />
                <Typography.Text type='secondary'>
                  {`For ${
                    !workspace.enableInternalFeedback ? 'Troopr ' : ''
                  }help docs, visit `}
                  <Typography.Link href={help_docs_link} target='_blank'>
                    here
                  </Typography.Link>
                </Typography.Text>
              </>
            )}
          </>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    workspace: store.common_reducer.workspace,
    user_now: store.common_reducer.user,
    channels: store.skills.channels,
  };
};

export default withRouter(
  connect(mapStateToProps, { sendUserFeedback, getChannelList })(FeedbackModal)
);
